"use client";

import Image from "next/image";

import { IHeroBannerOOS } from "@/types";

import BackNavigation from "../BackNavigation/BackNavigation";

function HeroBanner(props: IHeroBannerOOS) {
  const { bannerTitle, backgroundImage, breadcrumb } = props.entry;
  return (
    <section
      className={`
                w-100
                h-screen
                relative
            `}
    >
      <Image src={backgroundImage.url} alt={backgroundImage.description} fill={true} objectFit="cover" />
      <div
        className={`
                    container
                    mx-auto
                    h-full
                    flex
                    flex-col
                    ${breadcrumb ? "justify-between" : "justify-end"}
                    py-[1rem]
                `}
      >
        {/* @TODO: comment because this break releases */}
        {breadcrumb && <BackNavigation crumbs={breadcrumb} />}
        <h1
          className={`
                        z-10
                        font-primary
                        font-medium	
                        text-[20px]
                        text-[#FFFFFF]
                        text-center
                        uppercase
                        md:text-[32px]
                        md:w-[662px]
                        md:mx-auto	
                    `}
        >
          {bannerTitle}
        </h1>
      </div>
    </section>
  );
}

export default HeroBanner;
